import { Breadcrumbs, useBreadcrumbsModel } from '@workday/canvas-kit-react/breadcrumbs';
import { WcpStyles } from '@workday/wcp-tokens';
import React from 'react';
import { useSettledContainerModel } from '../hooks/useSettledContainerModel';

type BreadcrumbsItemProps = React.ComponentProps<typeof Breadcrumbs.Item>;
const ThemedBreadcrumbsItem: React.FC<BreadcrumbsItemProps> = (props) => {
  return <Breadcrumbs.Item {...props} fill={WcpStyles.color.icon.default} />;
};

type BreadcrumbsCurrentItemProps = React.ComponentProps<typeof Breadcrumbs.CurrentItem>;
const ThemedBreadcrumbsCurrentItem: React.FC<BreadcrumbsCurrentItemProps> = (props) => {
  return <Breadcrumbs.CurrentItem {...props} color={WcpStyles.color.text.default} />;
};

export const ThemedBreadcrumbs = (props: React.ComponentProps<typeof Breadcrumbs>) => {
  const ownedModel = useBreadcrumbsModel(props);
  const model = useSettledContainerModel(props.model ?? ownedModel);
  return <Breadcrumbs {...props} model={model} />;
};
ThemedBreadcrumbs.Item = ThemedBreadcrumbsItem;
ThemedBreadcrumbs.Link = Breadcrumbs.Link;
ThemedBreadcrumbs.CurrentItem = ThemedBreadcrumbsCurrentItem;
ThemedBreadcrumbs.List = Breadcrumbs.List;
